// 2 functions to fix the ada issues, to add a title to iframes and an alt to images who don't have it.

function addIframeTitles() {
    const iframes = document.querySelectorAll('iframe');
    
    iframes.forEach((iframe, index) => {
        if (!iframe.hasAttribute('title')) {
            iframe.setAttribute('title', `Embedded content ${index + 1}`);
        }
    });
}

document.addEventListener('DOMContentLoaded', addIframeTitles);

function addImageAlts() {
    const images = document.querySelectorAll('a > img, p > img, span > img');
    
    images.forEach((img, index) => {
        if (!img.hasAttribute('alt')) {
            img.setAttribute('alt', `Image ${index + 1}`);
        }
    });
}

document.addEventListener('DOMContentLoaded', addImageAlts);